import { render } from "./topicRelease.vue?vue&type=template&id=29a63e38&scoped=true"
import script from "./topicRelease.vue?vue&type=script&lang=js"
export * from "./topicRelease.vue?vue&type=script&lang=js"

import "./topicRelease.vue?vue&type=style&index=0&id=29a63e38&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a63e38"]])

export default __exports__